import type {ReactElement, ReactNode} from 'react';
import type {SxProps} from '@mui/material';
import {Chip, Paper, Stack, Typography, type ChipProps} from '@mui/material';
import {IconWrapper, type IconWrapperColor, type IconWrapperProps} from '../IconWrapper/IconWrapper';
import {COLORS} from '~/style/colors-ts';
import type {Theme} from "@emotion/react";

export type CardProps = {
    children?: React.ReactNode;
    icon?: ReactElement;
    title: ReactNode;
    subHeader?: React.ReactNode;
    status?: React.ReactNode;
    statusColor?: IconWrapperColor & NonNullable<ChipProps['color']>;
    iconProps?: Omit<IconWrapperProps, 'children'>;
    extraHeaderContent?: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    isActive?: boolean;
    sx?: SxProps<Theme>;
};

export function CustomCard({
                               children,
                               icon,
                               title,
                               subHeader,
                               status,
                               statusColor = 'default',
                               iconProps,
                               extraHeaderContent,
                               onClick,
                               isActive,
                               sx
                           }: CardProps) {
    return (
        <Paper
            variant="outlined"
            onClick={onClick}
            sx={{
                borderColor: 'grey.100',
                p:2,
                ...(isActive ? {borderColor: COLORS.info.main} : {}),
                ...(onClick ? {cursor: 'pointer'} : {}),
                ...sx
            }}
        >
            <Stack gap={1} flexGrow={1} sx={{height: '100%'}}>
                <Stack direction="row" gap={1}>
                    {icon && (
                        <IconWrapper color={statusColor} {...iconProps}>
                            {icon}
                        </IconWrapper>
                    )}
                    <Stack sx={{marginRight: 'auto',minWidth: 0}}>
                        <Typography noWrap overflow="hidden" textOverflow="ellipsis"  fontWeight={700} >{title}</Typography>
                        {subHeader && (
                            <Typography variant="caption" color="grey.600" sx={{height: 14.4}}>{subHeader}</Typography>
                        )}
                    </Stack>
                    {extraHeaderContent}
                    {status && (
                        <Chip variant="filled" label={status} color={statusColor} size="small" sx={{alignSelf: 'flex-start'}}/>
                    )}
                </Stack>
                {children}
            </Stack>

        </Paper>
    );
}
